import React, { useCallback } from 'react';

//Hooks
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

//Components
import { Switch, Route, useLocation, useHistory, Redirect } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import ScreenHeader from '../../../components/ScreenHeader/ScreenHeader';

//Routes
import MyProfile from '../MyProfile/MyProfile';
import LoyaltyPoints from '../LoyaltyPoints/LoyaltyPoints';
import Account from '../account/Account/Account';
import Settings from '../Settings/Settings';

import { ROUTER_URL } from '../../../const/ROUTER_URL';
import { ROUTER_PATH } from '../../../const/ROUTER_PATH';

const TITLE_MAP = {
    [ROUTER_PATH.PROFILE]: 'myProfile.title',
    [ROUTER_PATH.PROFILE_LOYALTY]: 'myProfile.loyaltyPoints.title',
    [ROUTER_PATH.PROFILE_ACCOUNT]: 'myProfile.editAccount.title',
    [ROUTER_PATH.PROFILE_ACCOUNT_PASSWORD]: 'myProfile.editPassword.title',
    [ROUTER_PATH.PROFILE_SETTINGS]: 'myProfile.settings.title',
};

const Profile = () => {
    const isSignedIn = useSelector(state => state.auth.isSignup);

    const { t } = useTranslation('common');
    const history = useHistory();
    const location = useLocation();

    const handleProfile = useCallback(() => {
        history.push(ROUTER_URL.PROFILE);
    }, [history]);

    const handleProfileAccount = useCallback(() => {
        history.push(ROUTER_URL.PROFILE_ACCOUNT);
    }, [history]);

    if (!isSignedIn) {
        return <Redirect to={ROUTER_URL.SIGN_IN_PROFILE} />
    }

    return (
        <>
            <ScreenHeader>
                <Breadcrumb>
                    {![ROUTER_PATH.PROFILE, ROUTER_PATH.PROFILE_SLASH].includes(location.pathname) ? (
                        <Breadcrumb.Item
                            style={{ fontSize: 12 }}
                            data-testid="backButton1"
                            onClick={handleProfile}
                        >
                            {t('myProfile.title')}
                        </Breadcrumb.Item>
                    ) : null}
                    {[ROUTER_PATH.PROFILE_ACCOUNT_PASSWORD].includes(location.pathname) ? (
                        <Breadcrumb.Item
                            style={{ fontSize: 12 }}
                            data-testid="backButton2"
                            onClick={handleProfileAccount}
                        >
                            {t('myProfile.editAccount.title')}
                        </Breadcrumb.Item>
                    ) : null}
                    <Breadcrumb.Item 
                        active 
                        data-testid={`data-test-breadcrumb-${location.pathname}`}
                    >
                        {t(TITLE_MAP[location.pathname])}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </ScreenHeader>

            <Switch>
                <Route
                    path={ROUTER_PATH.PROFILE}
                    exact
                    component={MyProfile}
                />
                <Route
                    path={ROUTER_PATH.PROFILE_LOYALTY}
                    component={LoyaltyPoints}
                />
                <Route
                    path={ROUTER_PATH.PROFILE_ACCOUNT}
                    component={Account}
                />
                <Route
                    path={ROUTER_PATH.PROFILE_SETTINGS}
                    component={Settings}
                />
            </Switch>
        </>
    )
}


export default Profile
